<template>
  <div
    class="VisionIndicator"
    :class="[
      'VisionIndicator--colour-' + props.colour
    ]"
  />
</template>

<script setup lang="ts">
export interface Props {
    colour: 'green' | 'gradient'
}

const props = withDefaults(defineProps<Props>(), {
  colour: 'green'
})
</script>

<style lang="postcss" scoped>
.VisionIndicator {
    @apply rounded-full w-3 h-3 relative;

    &:before {
      @apply content-[''] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full animate-[indicator-pulse_5s_forwards_infinite];
    }
}

.VisionIndicator--colour-green {
  @apply bg-green;

  &:before {
    @apply bg-green;
  }
}

.VisionIndicator--colour-gradient {
  @apply bg-gradient;

  &:before {
    @apply bg-gradient;
  }
}

@keyframes indicator-pulse {
  0% {
    @apply blur-0;
    -webkit-filter: blur(0);
  }

  50% {
    @apply blur-sm;
    -webkit-filter: blur(8px);
  }

  100% {
    @apply opacity-0;
  }
}
</style>